import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const COOKIE_CONSENT_KEY = "bodyz-gym-cookie-consent";

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-[400px] z-50 bg-card border border-border rounded-xl shadow-lg p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <h4 className="font-semibold text-sm mb-1">Cookie Consent</h4>
          <p className="text-xs text-muted-foreground mb-3">
            We use cookies to enhance your experience. By continuing to visit this site you agree to our{" "}
            <a href="/cookie-policy" className="text-amber-500 hover:underline">
              Cookie Policy
            </a>
            .
          </p>
          <div className="flex gap-2">
            <Button size="sm" onClick={handleAccept} className="bg-amber-500 text-black hover:bg-lime-500">
              Accept
            </Button>
            <Button size="sm" variant="outline" onClick={handleDecline}>
              Decline
            </Button>
          </div>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
